'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConjunctiveTimeWindowsIterator = ConjunctiveTimeWindowsIterator;

var _DisjunctiveAvailabilityIterator = require('./DisjunctiveAvailabilityIterator');

var _InverseTimeWindowsIterator = require('./InverseTimeWindowsIterator');

var _AvailabilityIterator = require('./AvailabilityIterator');

function ConjunctiveTimeWindowsIterator(_ref) {
    var _ref$iterators = _ref.iterators,
        iterators = _ref$iterators === undefined ? [] : _ref$iterators,
        cal = _ref.cal;


    iterators = iterators || []; // null isn't caught by default

    if (iterators.length > 0) {

        // A&B = ~(~A | ~B)
        return new _InverseTimeWindowsIterator.InverseTimeWindowsIterator({
            iterator: new _DisjunctiveAvailabilityIterator.DisjunctiveTimeWindowsIterator({
                iterators: iterators.map(function (it) {
                    return new _InverseTimeWindowsIterator.InverseTimeWindowsIterator({ iterator: it });
                }),
                cal: cal
            })
        });
    } else {
        // Special handler for no iterators (always closed)
        var alwaysClosedAvailability = { exceptions: [{ availabile: false }] };

        return new _AvailabilityIterator.AvailabilityIterator({
            availability: alwaysClosedAvailability,
            cal: cal
        });
    }
}